<template>
  <v-dialog v-model="visible" max-width="550" persistent>
    <v-card>
      <v-card-title class="text-h6"> Skapa kontakt </v-card-title>

      <v-card-text>
        <v-text-field
          label="För- och efternamn"
          clearable
          outlined
          v-model="name"
          :messages="message"
        ></v-text-field>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn text :to="{ name: 'ContactsHome' }"> Avbryt </v-btn>

        <v-btn color="primary" :disabled="!name" :loading="loading" @click="save"> Spara </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'ContactCreate',
  data() {
    return {
      visible: true,
      name: '',
      loading: false,
    }
  },
  computed: {
    firstName() {
      return this.name ? this.name.split(' ')[0] : ''
    },
    lastName() {
      return this.name &&  this.name.split(' ').length > 1 ? this.name.split(' ').slice(1).join(' ') : ''
    },
    message(){
      if(!this.firstName) return ''
      if(this.lastName) return `Förnamn: ${this.firstName}, efternamn: ${this.lastName}`
      return `Förnamn: ${this.firstName}`
    }
  },
  methods: {
    ...mapActions('contacts', { createContact: 'create' }),
    async save() {
      this.loading = true
      await this.createContact({
        contact_first_name: this.firstName,
        contact_last_name: this.lastName,
        contact_status: 'new',
      })
      this.loading = false
      this.$router.replace({ name: 'ContactsHome' })
    },
  },
}
</script>

<style lang="scss" scoped></style>
